import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme/constants';

export const MarginBottomContainer = styled.div`
  margin-bottom: ${gridSize() * 2};
`;
